module.exports = __webpack_public_path__ + "static/media/calendar-Icon.4d0811d9.svg";